import type { QcsResourceSlice } from '../core/resourceSliceUtils';

export const DOMAIN_LOGOS_REDUCER_KEY = 'domainLogosStore';
export const DOMAIN_LOGOS_VERSION_NUMBER = 3;

export type DomainLogoProps = {
  id?: string;
  domain: string;
  logoUrl?: string;
  modifiedAt?: string;
};

export type DomainLogosItemsState = QcsResourceSlice<DomainLogoProps> & {
  /**
   * Domains a lookup resolved without a logo. Distinguishes "fetched, no logo
   * exists" from "never fetched" so remounts do not refetch known misses.
   * Session-only: excluded from the persisted cache and cleared by store
   * resets, so each session (and dataset switch) retries misses once.
   */
  resolvedMisses: { [domain: string]: true };
};

/**
 * Persist transform for both platforms' cache configs. The negative cache is
 * session-only: a persisted miss would suppress a later-added logo
 * indefinitely.
 */
export const stateToCacheDomainLogos = (state: DomainLogosItemsState): DomainLogosItemsState => ({
  ...state,
  resolvedMisses: {},
});

declare module 'app-components/utils/redux-store/rootState' {
  export default interface RootState {
    [DOMAIN_LOGOS_REDUCER_KEY]: DomainLogosItemsState;
  }
}
